import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'phoenix-searchbox',
  template: `
    <mat-form-field [subscriptSizing]="'dynamic'" class="w-full">
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-icon matPrefix>search</mat-icon>
      <input
        #searchInput
        [attr.aria-label]="'searchInput'"
        matInput
        [formControl]="searchValue"
        (keyup.enter)="applyFilter($event)"
        (blur)="applyFilter($event)"
        [placeholder]="placeholder"
      />
      @if (searchValue.value) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (mousedown)="$event.preventDefault()"
          (click)="clearSearch()"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  `,
  standalone: false,
})
export class SearchboxComponent implements OnChanges, OnInit {
  @Input() searchValue = new FormControl<string>('');
  @Input() disabled = false;
  @Input() label?: string;
  @Input() placeholder = 'Search...';
  @Output() searchboxChange = new EventEmitter<string>();
  destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.searchValue.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        if (value?.trim() === '') {
          this.searchValue.setValue('', { emitEvent: false });
        }
      });
  }

  ngOnChanges(): void {
    if (this.disabled && this.searchValue.enabled) {
      this.searchValue.disable();
    } else if (!this.disabled && this.searchValue.disabled) {
      this.searchValue.enable();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.searchboxChange.emit(filterValue);
  }

  clearSearch() {
    this.searchValue.setValue('');
    this.searchboxChange.emit(this.searchValue.value || '');
  }
}
